import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { DropZone } from './DropZone';
import { DropZoneLabelFieldTextSettings } from './DropZoneLabelField';

export const DropZoneLayout = (object: DropZone) => {

    const { allowPeeking } = object;

    const base = new Rect(0, 0, object.width, object.height);
    const inner = base.inflate([-30, -30]);

    const labelHeight = TextRuler.measureHeight(
        object.actualLabel,
        DropZoneLabelFieldTextSettings,
        inner.width);

    const label = inner.set({
        height: labelHeight,
    });

    const peekHeight = allowPeeking ? 40 : 0;
    const peek = new Rect(
        inner.left + (inner.width / 2) - (100 / 2),
        inner.bottom - peekHeight,
        100,
        peekHeight,
    );

    const main = inner.set({
        top: label.bottom + 20,
        bottom: peek.top,
    });

    return { base, label, main, peek };
};

export type DropZoneLayout = ReturnType<typeof DropZoneLayout>;
